/* Eisfit: movimento automático. Abertura (fotos e vídeo curto), carrosséis e galeria do produto.
   Para sozinho quando a pessoa mexe, quando sai da tela, e não roda se ela pediu "reduzir movimento". */
(function () {
  'use strict';
  var d = document, w = window;
  if (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
  var saver = !!(navigator.connection && navigator.connection.saveData);
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }

  /* chama on() quando o elemento aparece na tela e off() quando sai */
  function watch(el, on, off) {
    if (!('IntersectionObserver' in w)) { on(); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { on(); } else { off(); } });
    }, { threshold: 0.3 }).observe(el);
  }
  /* pausa quando a pessoa toca, arrasta, usa o teclado ou está com o mouse em cima */
  function holdable(el, ms) {
    var st = { until: 0 };
    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(function (ev) {
      el.addEventListener(ev, function () { st.until = Date.now() + ms; }, { passive: true });
    });
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { st.until = Infinity; } });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { st.until = Date.now() + 2500; } });
    return st;
  }

  /* abertura: fotos que se trocam com suavidade e, no celular, o vídeo curto */
  function hero() {
    var root = $('[data-hero]');
    if (!root) { return; }
    var items = $$('.h2o-s', root), vid = $('[data-hero-video]', root), dots = $('[data-hero-dots]', root);
    var mobile = w.matchMedia ? w.matchMedia('(max-width: 899px)').matches : false;
    var cur = 0, timer = null, vis = false;
    if (items.length < 2 && !(vid && mobile)) { return; }
    function mark() { if (dots) { $$('i', dots).forEach(function (e, k) { e.classList.toggle('is-on', k === cur); }); } }
    function build() { if (dots) { dots.innerHTML = items.map(function () { return '<i></i>'; }).join(''); mark(); } }
    function show(n) {
      cur = (n + items.length) % items.length;
      items.forEach(function (el, k) {
        var on = k === cur;
        el.classList.toggle('is-on', on);
        if (el === vid) {
          if (on) { try { vid.currentTime = 0; var p = vid.play(); if (p && p.catch) { p.catch(function () {}); } } catch (e) {} } else { vid.pause(); }
        }
      });
      mark();
    }
    function stop() { if (timer) { w.clearTimeout(timer); timer = null; } }
    function go() { stop(); timer = w.setTimeout(function () { show(cur + 1); go(); }, items[cur] === vid ? 5400 : 4800); }
    build();
    watch(root, function () { vis = true; go(); }, function () { vis = false; stop(); });
    d.addEventListener('visibilitychange', function () { if (d.hidden) { stop(); } else if (vis) { go(); } });
    if (vid && mobile && !saver) {
      var load = function () {
        vid.muted = true;
        vid.addEventListener('canplay', function () {
          if (items.indexOf(vid) > -1) { return; }
          items.splice(1, 0, vid);
          if (cur >= 1) { cur += 1; }
          build();
        }, { once: true });
        vid.src = vid.getAttribute('data-src');
        vid.load();
      };
      if (d.readyState === 'complete') { w.setTimeout(load, 900); } else { w.addEventListener('load', function () { w.setTimeout(load, 900); }); }
    }
  }

  /* carrosséis (cores etc.): avança de tempos em tempos e volta ao começo */
  function car(el) {
    var tr = $('[data-car-track]', el), items = tr ? $$('.car-i', tr) : [];
    if (!tr || items.length < 2) { return; }
    var vis = false, hold = holdable(el, 9000);
    function step() { return Math.max(1, items[1].offsetLeft - items[0].offsetLeft); }
    function next() {
      var max = tr.scrollWidth - tr.clientWidth - 4;
      if (max <= 4) { return; }
      if (tr.scrollLeft >= max) { tr.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { tr.scrollBy({ left: step() * Math.max(1, Math.round(tr.clientWidth / step())), behavior: 'smooth' }); }
    }
    watch(el, function () { vis = true; }, function () { vis = false; });
    w.setInterval(function () { if (vis && !d.hidden && Date.now() >= hold.until) { next(); } }, 3600);
  }

  /* galeria do produto: passa as fotos sozinha até a pessoa mexer ou ampliar */
  function gal(el) {
    var nx = $('[data-gal-next]', el);
    if (!nx) { return; }
    var vis = false, hold = holdable(el, 12000);
    watch(el, function () { vis = true; }, function () { vis = false; });
    w.setInterval(function () {
      var lb = $('[data-lb]');
      if (vis && !d.hidden && Date.now() >= hold.until && !(lb && lb.open)) { nx.click(); }
    }, 4200);
  }

  function init() { hero(); $$('[data-car]').forEach(car); $$('[data-gal]').forEach(gal); }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
